import React from 'react';
import LoginForm from 'components/auth/LoginForm';
import { Card, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

export default function LoginPage() {
  const { t } = useTranslation();
  return (
    <Row justify="center" align="middle" style={{ flex: 1 }}>
      <Col xs={24} md={10} style={{ padding: 20 }}>
        <Card title={t('Login.title')}>
          <LoginForm />
        </Card>
      </Col>
    </Row>
  );
}
